module.exports = "/dist/assets/images/register-banner.jpg";